import { useSyncExternalStore } from 'react';
import { api } from './api';

/**
 * Сколько рейсов изменилось с последнего захода в раздел.
 *
 * Хранилище, а не состояние компонента, по той же причине, что у ширины
 * меню (`navWidth.ts`) и торгов (`auctions.ts`): цифру рисует навигация —
 * и нижняя, и боковая, — а приходит она из опроса, который делает
 * колокольчик, и из событий сокета. Через свойства это пришлось бы
 * протаскивать через полдесятка компонентов.
 *
 * Зачем значок: отклик приняли — у перевозчика появился рейс, и узнаёт
 * он об этом либо из Telegram, либо случайно, заглянув в раздел. Между
 * этими двумя моментами машина стоит.
 */

let count = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function setFreshOrders(n: number): void {
  if (n === count) return;
  count = n;
  emit();
}

/** Событие по рейсу пришло в сокет — значок реагирует сразу. */
export function bumpFreshOrders(): void {
  count += 1;
  emit();
}

/**
 * Раздел открыт — значок гаснет.
 *
 * Цифра убирается сразу, не дожидаясь ответа сервера: человек уже
 * смотрит на список, и значок, висящий ещё секунду, выглядит как
 * «система не заметила». Отметка на сервере идёт следом и молча —
 * не прошла, значит значок вернётся при следующем опросе, что честно.
 */
export function markOrdersSeen(): void {
  setFreshOrders(0);
  void api.markOrdersSeen().catch(() => {});
}

export function useFreshOrders(): number {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => count,
    () => count,
  );
}
